import React from 'react'

const GridProductsSlider = () => {
  return (
    <div>Grid Products Slider</div>
  )
}

export default GridProductsSlider